import React, { useContext } from 'react';

import {
  ButtonTheme,
  SegmentedControl,
  Select,
} from '@imgly/imgly-website-components';
import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';

import { PageContext } from '../../context/PageContext';
import { getInternalPath } from '../../utils';

import * as classes from './style.module.scss';

interface Props {
  products: Record<string, Array<string>>;
}

export const ProductSwitch: React.FC<Props> = ({ products }) => {
  const { product, name } = useContext(PageContext);
  const { pathname } = useLocation();

  /**
   * {
    pesdk: ['PhotoEditor SDK', 'https://img.ly/docs/pesdk/'],
    vesdk: ['VideoEditor SDK', 'https://img.ly/docs/vesdk/'],
    cesdk: ['CreativeEditor SDK', 'https://img.ly/docs/cesdk/'],
  }
   */
  const options = Object.entries(products).map(([key, values]) => ({
    value: key,
    label: values[0],
  }));

  const handleChange = (value: string | number | null) => {
    if (typeof value === 'string') {
      navigate(getInternalPath(products[value][1], pathname, name));
    }
  };

  return (
    <div className={classes.root}>
      <SegmentedControl
        className={classes.segmented}
        name="product-switch"
        label="Switch to a different product"
        hideLabel
        small={false}
        activeTheme={ButtonTheme.Primary}
        value={product || ''}
        options={options}
        onChange={handleChange}
      />
      <Select
        className={classes.select}
        label={product ? products[product][0] : products[0][0]}
        value={product || ''}
        small={false}
        options={options}
        onChange={handleChange}
      />
    </div>
  );
};
